import { Controller } from "@hotwired/stimulus";

const EVENTS_TO_VALIDATE = ["change", "autocomplete.change"];

export default class extends Controller {
  overlay;

  static targets = ["submitButton"];

  declare readonly submitButtonTargets: HTMLButtonElement[];
  declare readonly hasSubmitButtonTarget: boolean;

  formElements: NodeListOf<
    HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
  >;

  initialize(): void {
    this.validate = this.validate.bind(this);
  }

  connect() {
    this.formElements = this.element.querySelectorAll(
      "input, textarea, select"
    );
    this.formElements.forEach((element) => {
      EVENTS_TO_VALIDATE.forEach((eventName) => {
        element.addEventListener(eventName, this.validate);
      });
    });

    this.validate();
  }

  disconnect() {
    this.formElements.forEach((element) => {
      EVENTS_TO_VALIDATE.forEach((eventName) => {
        element.removeEventListener(eventName, this.validate);
      });
    });
  }

  validate() {
    const form = this.formElements[0] && this.formElements[0].form;
    const previousValue = form ? form?.noValidate : false;
    if (form) form.noValidate = false;
    const isValid = Array.from(this.formElements).every((element) =>
      element.checkValidity()
    );

    this.submitButtonTargets.forEach((element) => {
      element.disabled = !isValid;
    });

    if (form) form.noValidate = previousValue;
  }

  cancel(event: Event) {
    event.preventDefault();
    if (document.referrer.split("/")[2] === window.location.host) {
      history.back();
    } else {
      window.location.href = window.location.href.replace(/\/new.*$/, "");
    }
  }
}
